/*
    此文件为数据接口存放命名，为防止接口太多，造成接口混乱
    命名为大写斜杠
    按页面划分
    例如： 'ORDER_API': '/api/order',
    每个接口注释用途，为方面其他开发人员查找，了解。
    export default {

    } 
*/
export default {
  /**查询列表 */
  GET_LIST_API: '/maindata/application/listApplication',
  ADD_APP_API: '/maindata/application/saveApplication',
  UPDATE_APP_API: '/maindata/application/updateApplication',
  DELETE_APP_API: '/maindata/application/deleteApplication',
};
